import * as React from 'react'
import { ReactElement } from 'react'

export function KeyPressListener({
  watchKey,
  keyPressChange,
  children,
}: {
  keyPressChange: (pressed: boolean) => void
  watchKey: string
  children?: ReactElement
}) {
  React.useEffect(() => {
    window.addEventListener('keydown', downHandler)
    window.addEventListener('keyup', upHandler)
    return () => {
      window.removeEventListener('keydown', downHandler)
      window.removeEventListener('keyup', upHandler)
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [])

  function downHandler({ key: pressed }: KeyboardEvent) {
    if (watchKey === pressed) {
      keyPressChange(true)
    }
  }

  function upHandler({ key: released }: KeyboardEvent) {
    if (watchKey === released) {
      keyPressChange(false)
    }
  }
  return <>{children}</>
}
